import { render, staticRenderFns } from "./TemplateCreateNormal.vue?vue&type=template&id=83538c6e&"
import script from "./TemplateCreateNormal.vue?vue&type=script&lang=js&"
export * from "./TemplateCreateNormal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCreateNormal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports